/**
 * Resolves the T1 (root) ancestor title for a risk in the hierarchy.
 *
 * Walks up the ParentRiskId chain from the given risk until a Tier 1
 * ancestor is found. Returns null if the chain is broken (orphaned) or
 * if a cycle is detected (max-depth guard).
 */
export const getT1CategoryTitle = (
  risk: {
    Id: string;
    Tier: number;
    Title: string;
    ParentRiskId?: string | null;
  },
  riskById: Map<
    string,
    { Id: string; Tier: number; Title: string; ParentRiskId?: string | null }
  >
): string | null => {
  if (risk.Tier === 1) {
    return risk.Title;
  }
  let current: typeof risk | undefined = risk;
  let depth = 0;
  while (current?.ParentRiskId && depth < 10) {
    current = riskById.get(current.ParentRiskId);
    if (current?.Tier === 1) {
      return current.Title;
    }
    depth++;
  }

  return null;
};
